import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import { BALANCE_SHEET_ROW_CLASSNAME, BalanceSheetRowVariant, useBalanceSheetRowStyles } from './BalanceSheetRow.styles';
export interface BalanceSheetRowProps {
  /**
   * Child cells to render in the row
   */
  children: React.ReactNode;
  /**
   * Whether hover state should be enabled.
   * Typically disabled in presentation/export contexts.
   * @default true
   */
  enableHover?: boolean;
  /**
   * 'contents' (default): children become direct grid items of the parent grid.
   * 'stickyHeader': row uses CSS subgrid with position: sticky to stay visible while scrolling.
   * @default 'contents'
   */
  variant?: BalanceSheetRowVariant;
  /**
   * The top offset (in px) for sticky positioning. Only used when variant is 'stickyHeader'.
   * @default 0
   */
  stickyTop?: number;
  role?: 'row';
}

/**
 * BalanceSheetRow provides a container for BalanceSheetCell components
 * that ensures proper vertical alignment and height matching across cells.
 *
 * This component handles the flex layout so that all cells in a row
 * stretch to match the height of the tallest cell.
 */
export function BalanceSheetRow(t0) {
  const $ = _c(8);
  const {
    children,
    enableHover: t1,
    variant: t2,
    stickyTop: t3,
    role
  } = t0;
  const enableHover = t1 === undefined ? true : t1;
  const variant = t2 === undefined ? "contents" : t2;
  const stickyTop = t3 === undefined ? 0 : t3;
  let t4;
  if ($[0] !== enableHover || $[1] !== stickyTop || $[2] !== variant) {
    t4 = {
      enableHover,
      variant,
      stickyTop
    };
    $[0] = enableHover;
    $[1] = stickyTop;
    $[2] = variant;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const {
    classes
  } = useBalanceSheetRowStyles(t4);
  const t5 = `${classes.root} ${BALANCE_SHEET_ROW_CLASSNAME}`;
  let t6;
  if ($[4] !== children || $[5] !== role || $[6] !== t5) {
    t6 = <Box className={t5} role={role}>{children}</Box>;
    $[4] = children;
    $[5] = role;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}